<!--
  - Copyright (c) ProviderTrust LLC.
  - All Rights Reserved.
  -
  - This software is confidential and proprietary information of
  - ProviderTrust LLC ("Confidential Information"). You shall not disclose
  - such Confidential Information and shall use it only in
  - accordance with the terms of the license agreement you entered
  - into with ProviderTrust.
  -->
<template>
  <div
    :class="['ec-dropdown', { 'ec-dropdown-active': showDropdown }]"
    @mouseleave="showDropdown = false"
  >
    <div class="ec-dropdown-activator" @click="showDropdown = !showDropdown">
      <slot name="activator" />
    </div>

    <div class="ec-dropdown-menu" @click="closeDropdown" v-show="showDropdown">
      <slot />
    </div>
  </div>
</template>
<script>
export default {
  name: "ECDropdown",

  props: {
    disappearOnClick: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    showDropdown: false
  }),
  methods: {
    closeDropdown() {
      if (this.showDropdown && this.disappearOnClick) {
        this.showDropdown = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.ec-dropdown {
  position: relative;

  &-menu {
    position: absolute;
    z-index: 1;
    box-shadow: 0 6px 3px 0 rgba(0, 0, 0, 0.23),
      0 10px 10px 0 rgba(0, 0, 0, 0.19);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Dropdown.vue